import {Injectable, Injector} from '@angular/core';
import {Router} from '@angular/router';
import {Subject} from 'rxjs';


import {BaseService} from '../base/base.service';
import {Company} from '../../models/lookups/company';
import {Stockroom} from '../../models/stockroom/stockroom';
import {AppModulePath} from '../../models/app-module-path';

import {WebMethodResult} from '../../models/web-method-result';
import {SecurityService} from './security.service';
import {HttpClient} from '@angular/common/http';
import {PlatformLocation} from '@angular/common';
import {isNil} from 'lodash';


@Injectable({ providedIn: 'root' })
export class ClientSettingsService extends BaseService {
  private setActiveCUrl = 'api/settings/set_active_company';
  private setActiveSUrl = 'api/settings/set_active_stockroom';
  onChangeActiveStockroom = new Subject();

  constructor(protected injector: Injector,
              protected http2: HttpClient,
              protected platformLocation: PlatformLocation,
              private router: Router,
              private securityService: SecurityService) {
    super(injector, http2, platformLocation);
  }

  activeStockroom() {
    this.onChangeActiveStockroom.next();
  }

  private sessionExpired() {
  }

  private getUserId(): string | null {
    if (!isNil(this.securityService.loggedUser)) {
      return String(this.securityService.loggedUser.id);
    }
    const stored = localStorage.getItem('loggedUser');
    if (!isNil(stored)) {
      try {
        const id = JSON.parse(stored).id;
        return !isNil(id) ? String(id) : null;
      } catch {}
    }
    return null;
  }

  public getActiveCompany(): Company {
    const userId = this.getUserId();
    if (!isNil(userId)) {
      const companyStr = localStorage.getItem(userId + '-activeCompany');
      if (!isNil(companyStr)) {
        return new Company(JSON.parse(companyStr));
      }
    }
    return null;
  }

  public setActiveCompany(acomp: Company) {
    const userId = this.getUserId();
    if (!isNil(userId) && !isNil(acomp)) {
      localStorage.setItem(userId + '-activeCompany', JSON.stringify(acomp));
    } else {
      this.sessionExpired();
    }
  }

  public resetActiveCompany() {
    const userId = this.getUserId();
    if (!isNil(userId)) {
      localStorage.removeItem(userId + '-activeCompany');
    } else {
      this.sessionExpired();
    }
  }

  public getActiveStockroom(): Stockroom {
    const userId = this.getUserId();
    if (!isNil(userId)) {
      const str = localStorage.getItem(userId + '-activeStockroom');
      if (!isNil(str)) {
        return new Stockroom(JSON.parse(str));
      }
    }
    return null;
  }

  public setActiveStockroom(astr: Stockroom) {
    const userId = this.getUserId();
    if (!isNil(userId) && !isNil(astr)) {
      localStorage.setItem(userId + '-activeStockroom', JSON.stringify(astr));
    } else {
      this.sessionExpired();
    }
  }

  public resetActiveStockroom() {
    const userId = this.getUserId();
    if (!isNil(userId)) {
      localStorage.removeItem(userId + '-activeStockroom');
    } else {
      this.sessionExpired();
    }
  }
}
